import {combineReducers} from 'redux-immutable';
import studentList from './student_list/studentListReducers'
import ModalData from './ModalReducers'
import templateData from './template/templateReducers'
import DeviseUser from './DeviseUserReducers'
import ApplicationForAdmissionReducers from './ApplicationForAdmissionReducers'
import TransferStudentReducers from './TransferStudentReducers'
import ParentalStatusSurveyReducers from './ParentalStatusSurveyReducers'
import HealthQuestionnaire from './HealthQuestionnaireReducers'
import ParentPass from './ParentPassReducers'
import BrothersMember from './BrothersMemberReducers'
import { reducer as formReducer } from 'redux-form/immutable'
import { routerReducer } from 'react-router-redux'
import FamilyMember from './FamilyMemberReducers'

const rootReducer = combineReducers({
    studentList,
    templateData,
    DeviseUser,
    ApplicationForAdmissionReducers,
    TransferStudentReducers,
    ParentalStatusSurveyReducers,
    HealthQuestionnaire,
    ParentPass,
    ModalData,
    BrothersMember,
    FamilyMember,
    form: formReducer,
    routing: routerReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/index.jsx